const validate = values => {
    const errors = {};

    if (!values.accountID) {
        errors.accountID = "Påkrævet felt";
    }


    if (!values.firstname) {
        errors.firstname = 'Påkrævet felt';
    }

    if (!values.surname) {
        errors.surname = 'Påkrævet felt';
    }

    if (!values.password) {
        errors.password = 'Påkrævet felt';
    } else if (values.password.length < 6) {
        errors.password = 'mindst 6 bogstaver';
    }
    if (!values.confirmPassword) {
        errors.confirmPassword = 'Påkrævet felt';
    }

    if (!values.email) {
        errors.email = 'Påkrævet felt';
    }

    if (values.email) {
        const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(values.email)) {

        } else {
            errors.email = 'Ugyldig E-mail';
        }
    }

    if (!values.Password) {
        errors.Password = 'Påkrævet felt';
    }

    if (!values.confirmPassword) {
        errors.confirmpassword = 'Påkrævet felt';
    } else if (values.confirmPassword !== values.password) {
        errors.confirmPassword = 'kodeord uoverensstemmelse';
    }

    console.warn(errors);
    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/components/signup_partners/validateOrganicSignup.js